import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useObservableState } from 'observable-hooks';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useService } from '../../../services/services';
import { RootState } from '../../../store/store';
import { can, route } from '../../../services/utils';
import {
  LIVESTOCK_BARN_INDEX,
  LIVESTOCK_BARN_EDIT,
} from '../../../router/routes';
import Barn from '../../../interfaces/barn';
import Form from '../../../components/form';
import Link from '../../../components/form/elements/link';
import Readonly from '../../../components/form/elements/readonly';
import Text from '../../../components/form/elements/text';
import Group from '../../../components/form/elements/group';
import TextArea from '../../../components/form/elements/text-area';
import Date from '../../../components/form/elements/date';
import Barns from './view-barn-component';

export default function ViewBarn() {
  const { t } = useTranslation();
  const { farmId, id } = useParams<{ farmId: string; id: string }>();
  const { barnService } = useService();
  const [body, setBody] = useState([]);
  const [footer, setFooter] = useState([]);
  const [barn] = useObservableState<Barn>(
    () => barnService.show(farmId, id),
    null
  );
  const { farmUser } = useSelector((state: RootState) => ({
    farmUser: state.global.farmUser,
  }));

  useEffect(() => {
    if (barn) {
      setBody([
        Readonly([
          Group([
            Barns(
              {
                name: 'barns',
                mode: 'view',
                components: () => [
                  Text('ldc_nr', t('pages.livestock.barn.ldc_nr')),
                  Text('name', t('pages.livestock.barn.name')),
                  Text('location', t('pages.livestock.barn.location')),
                  TextArea(
                    'prohibitions',
                    t('pages.livestock.barn.prohibitions')
                  ),
                  Date(
                    'register_date',
                    t('pages.livestock.barn.register_date')
                  ),
                  Date(
                    'elimination_date',
                    t('pages.livestock.barn.elimination_date')
                  ),
                  Text('coordinates', t('pages.livestock.barn.coordinates')),
                  Text('notes', t('pages.livestock.barn.notes')),
                ],
              },
              barn
            ),
          ]),
        ]),
      ]);

      setFooter(() => {
        let elements = [];

        if (can(farmUser, { title: 'update barn' })) {
          elements.push(
            Link(route(LIVESTOCK_BARN_EDIT, { farmId, id }), 'edit', true)
          );
        }

        return elements;
      });
    }
  }, [barn, farmUser, farmId, id, t]);
  const formTitle = barn
    ? t('pages.livestock.barn.title') + ' ' + barn.ldc_nr
    : t('pages.livestock.barn.title');

  return (
    <Form
      title={formTitle}
      body={body}
      footer={footer}
      mode="view"
      backTo={route(LIVESTOCK_BARN_INDEX, { farmId })}
      values={barn}
      noticeAccessor="ViewForm"
    />
  );
}
